<template>
    <div class="" id="print-auc-info">
        <header class="card-header">
            <p class="card-header-title">Auction Info:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon ">
                    <i class="fas fa-gavel"></i>
                  </span>
            </a>
        </header>
        <div class="">
            <div class="content">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Lot#:</th>
                        <td>{{ lot.lot_num }}</td>
                    </tr>
                    <tr>
                        <th>Date & time:</th>
                        <td>{{ lot.auct_date }}</td>
                    </tr>
                    <tr>
                        <th>Auction:</th>
                        <td>{{ lot.auct_name }}</td>
                    </tr>
                    <tr>
                        <th>Score:</th>
                        <td><strong class="has-text-danger">{{ lot.rate }}</strong></td>
                    </tr>
                    <tr>
                        <th>Price:</th>
                        <td><strong>{{ lot.price_start | formatNumber }}</strong></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props:['lot'],

        methods: {


        }
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>




// WEBPACK FOOTER //
// src/components/StockCars/AucInfoStock.vue